import { AccountState } from '@slices/account';

import { Account } from '@types';

import { appCreateSelector, RootState } from '@store';

export const accountGet = (state: RootState): AccountState => {
  return state.app.account;
};

export const accountGetMe: (
  state: RootState //
) => Account = appCreateSelector(
  [accountGet], //
  (account) => account.me
);
